export default {
  workbench: "工作台",
  taskCenter: "任務中心",
  messageNotification: "訊息提醒",
  supplierManagement: "供應商管理",
  supplierProfileManagement: "供應商檔案管理",
  emailInvite: "郵箱邀請",
  supplierProfileDetail: "供應商檔案詳情",
  supplierPerformanceManagement: "供應商績效管理",
  assessmentTemplateManagement: "評估模板管理",
  admissionAssessmentTemplate: "準入評估模板",
  performanceAssessmentTemplate: "績效考核模板",
  addTemplate: "添加模版",
  supplierExceptionManagement: "供應商異常管理",
  supplierRiskLevel: "供應商風險登記",
  materialException: "物料異常登記",
  supplierVisitAuditManagement: "供應商拜訪與審計管理",
  visitManagement: "拜訪管理",
  auditManagement: "審計管理",
  requirementManagement: "需求管理",
  sourcingApplicationManagement: "尋源申請管理",
  purchaseApplicationManagement: "採購申請管理",
  priceInquiryManagement: "詢比價管理",
  priceCompareDetail: "詢比價詳情",
  contractManagement: "合約管理",
  purchaseOrderManagement: "採購訂單管理",
  systemSettings: "系統設置",
  changePassword: "修改密碼",
  orderDetail: "訂單詳情",
};
